export const PDF_VIEWER_THUMBNAIL_WIDTH = 132

// the placeholder ratio of an A4 page, until the real page is rendered
export const PDF_VIEWER_THUMBNAIL_HEIGHT = 187

export const PDF_VIEWER_THUMBNAIL_SCROLL_INTO_VIEW_OPTIONS = {
  block: 'nearest',
}

export const QA_NAME_PDF_VIEWER_THUMBNAIL = 'pdfViewerThumbnail'
